var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 15.523 4.47699 20 10 20C15.523 20 20 15.523 20 10C20 4.47699 15.523 0 10 0C4.47699 0 0 4.47699 0 10ZM8.75 6.25C8.75 5.55965 9.30965 5 10 5C10.6904 5 11.25 5.55965 11.25 6.25V8.75H13.75C14.4404 8.75 15 9.30965 15 10C15 10.6904 14.4404 11.25 13.75 11.25H11.25V13.75C11.25 14.4404 10.6904 15 10 15C9.30965 15 8.75 14.4404 8.75 13.75V11.25H6.25C5.55965 11.25 5 10.6904 5 10C5 9.30965 5.55965 8.75 6.25 8.75H8.75V6.25Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddto);
export default __webpack_public_path__ + "static/media/addto.d517e6649bf6aaea2895fc28ac6e3929.svg";
export { ForwardRef as ReactComponent };